<template>
  <div>
    <div v-for="(day, index) in days" :key="index">
      <time-logs :date="day.date" :timeLogs="timeLogs" :showEdit="true"></time-logs>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters } from 'vuex';

  import totalsCounterMixin from '@/store/modules/timeLog/mixins/totalsCounter';
  import TimeLogs from '@/components/timeLog/TimeLogs';

  export default {
    name: 'TimeLogsWeekView',
    props: {
      week: {
        type: [Number, String],
        required: true,
        default: moment().week(),
      },
      year: {
        type: [Number, String],
        required: true,
        default: moment().year(),
      },
      editable: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      timeLogs: TimeLogs,
    },
    mixins: [totalsCounterMixin],
    mounted() {
      this.fetchTimeLogs();
    },
    data() {
      return {
        viewMode: 'week',
      };
    },
    computed: {
      ...mapGetters('entities/timeLogs', ['fetching']),

      startOfWeek() {
        return moment(`${this.week} ${this.year}`, 'ww gggg').startOf('week');
      },
      endOfWeek() {
        return moment(`${this.week} ${this.year}`, 'ww gggg').endOf('week');
      },

      timeLogs() {
        return this.$store.getters['entities/timeLogs/query']()
          .with('category')
          .where(record => record.stopped_at !== null)
          .where(record => moment(record.started_at).isBetween(this.startOfWeek, this.endOfWeek))
          .where('deleted', false)
          .orderBy('started_at', 'asc')
          .get();
      },

      // timeLogs() {
      //   return this.$store.getters['entities/timeLogs/query']()
      //     .where(record => moment(record.started_at).isBetween(this.startOfWeek, this.endOfWeek) && record.user_id === this.userId)
      //     .get();
      // },

      days() {
        const daysCount = 7;
        const days = [];
        for (let i = 1; i < daysCount + 1; i += 1) {
          const date = this.startOfWeek.clone().add(i - 1, 'days');
          const obj = {
            day: i,
            date,
          };
          days.push(obj);
        }
        return days;
      },

      isCurrentWeek() {
        return this.week === moment().week();
      },

    },
    methods: {
      fetchTimeLogs() {
        const params = {
          mode: 'week',
          week: this.week,
          year: this.year,
        };
        return this.$store.dispatch('entities/timeLogs/fetchTimeLogs', params);
      },
    },

    watch: {
      week(newValue) {
        if (newValue) {
          this.fetchTimeLogs();
        }
      },

      year(newValue) {
        if (newValue) {
          this.fetchTimeLogs();
        }
      },
    },

  };
</script>

<style lang="scss">
  @import '../../assets/scss/variables';

  .month{
    display: block;
    padding: 0px;
    background-color: $--saffron-red-delight;
    color: #fff;
    border:{
      radius: 5px;
    }
    font:{
      size: 32px;
    }
    line-height: 70px;
    text:{
      align: center;
    }
    width: 70px;
    height: 70px;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/timeLog/TimeLogsWeekView.vue